import React from "react";
import { useSelector } from "react-redux";
import { File } from "../../../../../../../../../../components";
import { PencilIcon } from "../../../../../../../../../../components/Icons";
import { getSelfServiceProductImageSelector } from "../../../../../../../../../../store/selfServiceSlice";
import { useHandlers } from "./hooks";
import "./index.scss";

/**
 * @desc Input product image for product form.
 */
export const FileProductImage = ({ product, children }) => {
  const { handleChange } = useHandlers({ product });

  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: `${product.sku}-file-product-image-error`,
  };

  const inputProps = {
    id: `${product.sku}-file-product-image`,
    className: "form-control convention-input d-none",
    "aria-describedby": errorProps.id,
    accept: "image/*",
    onClick: (e) => {
      e.target.value = null;
    },
    onChange: async (e) => {
      handleChange(e);
    },
  };

  const labelProps = {
    className: "form-control-label edit-container",
    htmlFor: inputProps.id,
    children,
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
  };

  return <File {...parentProps} />;
};

/**
 * @desc Product row image for self service form.
 */
export const ProductRowImage = ({ product }) => {
  const productImage = useSelector(getSelfServiceProductImageSelector)(
    product.sku
  );

  // METHODS ------------------------------------------------------------------

  const renderSoldOutBadge = () => {
    if (!product.isSoldOut) return;
    return (
      <div className="flag-container">
        <div className={"flag"}>
          <div className={"flag-text"}>SOLD OUT</div>
        </div>
      </div>
    );
  };

  // COMPONENT ----------------------------------------------------------------

  return (
    <div className={`product-row-image ${product.isSoldOut ? "sold-out" : ""}`}>
      <img className={"product-image"} src={productImage} alt={product.name} />
      <FileProductImage product={product}>
        <PencilIcon width={13} height={13} />
        <div>EDIT</div>
      </FileProductImage>
      {renderSoldOutBadge()}
    </div>
  );
};

export default ProductRowImage;
